/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { Button } from 'antd';
import skinPrepPDF from '../../../assets/pdfs/Skin_Prep.pdf';
import termsAndConditionsPDF from '../../../assets/pdfs/Terms_and_Conditions.pdf';
import shippingLabelPDF from '../../../assets/pdfs/Shipping_Label.pdf';
import shippingInfoPDF from '../../../assets/pdfs/Shipping_Info.pdf';
import { ORDER_SERVICE_TYPES } from '../../../models';

export function Faq() {
    return (
        <div className="resources-faq">
            <div id="legal-faqs" className="anchor" />
            <h2 className="add-top">Legal FAQs</h2>
            <p>
                Question: I hired a trapper to trap my property and he gave me the raw fur, can I
                send it in?
            </p>
            <span>
                Answer: No. The proper way to do this is to have the licensed trapper or wildlife
                control specialist send the fur to us in his name. Then he may give you the dressed
                fur and you may pay him for the tanning.
            </span>
            <p>
                Question: A friend of mine gave me some skins as a gift; may I send them in with his
                license and information?
            </p>
            <span>
                Answer: No. The harvester of the wildlife must be the one who sends in the fur. Then
                he may give you the dressed skins.
            </span>
            <p>
                Question: I purchased some raw fur and in my state it is not required to have a fur
                buyer's license if the skins are for personal use; can I send those in?
            </p>
            <span>
                Answer: No. Although this may be legal in your state, it is against our company
                policy. We cannot possibly keep track of every exception to every law for every
                animal in every state. Therefore, we do not accept purchased raw fur unless the
                client has a fur buyer's license. We are sorry for the inconvenience.
            </span>
            <p>
                Question: If you do not accept purchased raw fur from individuals other than those
                with a fur buyer's license, how can I have the legally raw fur I purchased for
                personal use tanned?
            </p>
            <span>
                Answer: In this case we recommend that you take it to a professional taxidermist in
                your state that is familiar with the local regulations. He may accept the fur in his
                logbook, if legal in your state, and then send the raw fur to us by using his
                qualified client status as a professional taxidermist.
            </span>
            <p>
                Question: Do I have to send a signed Lacey Act Compliance Statement in with each
                order, or can I just sign one for all of my shipments?
            </p>
            <span>
                Answer: You must send a signed statement with each order. This is the only way we
                can be sure to protect your order in the event of a search by wildlife agencies.
            </span>
            <p>
                Question: In my state taxidermists are allowed to remove government tags once we
                inventory the raw hides. So I should be able to send you hides with the tags
                removed, correct?
            </p>
            <span>
                Answer: Not if your going to ship it out of state, or if it was harvested in another
                state.
                <ul>
                    <li>
                        Origen of Wildlife: One must remember that state laws pertain only to
                        animals harvested within the state. For example, if your state law permits
                        you to remove tags from a bobcat once you have inventoried it in your shop,
                        that state statute only pertains to bobcats harvested in your state. So you
                        may not remove a tag from an Idaho bobcat, for example, no matter what your
                        state taxidermy regulations say because the law from Idaho applies even if
                        you are practicing taxidermy in Michigan.
                    </li>
                    <li>
                        Out of State shipping : While many taxidermy regulations may state that the
                        taxidermist may remove the tags from raw hides once inventoried in the
                        taxidermy shop, that may not hold true if you ship the items out of your
                        shop or out of state. Many states may allow you to remove the tags in your
                        shop; however, these same states may have a regulation requiring a raw fur
                        being shipped out of state to be tagged. If this the case, you have to have
                        a tag on it to ship it out of state, even if you can take the tags of in
                        your shop.
                    </li>
                    <li>
                        Inter-State Commerce: if you are shipping your items out of state to be
                        tanned, just as a precaution you should never remove the tags because you
                        will be sending it into a state with different regulations and the last
                        thing anyone wants to do is try to explain to a wildlife agent that the
                        skins were harvested in state A, were being mounted in State B, but were
                        sent to a tannery in State C. All these states will have different
                        regulations with different agents enforcing them. So never remove you tags.
                        Secondly, once the skin leaves the state of origin, it is now subject to the
                        jurisdiction of US Fish & Wildlife and the LACEY ACT. Don't mess with
                        either.
                    </li>
                </ul>
            </span>
        </div>
    );
}
export default Faq;

export const WildlifeResources = [
    {
        name: 'US Fish and Wildlife',
        url: 'http://www.fws.gov/',
    },
    {
        name: 'Alabama',
        url: 'http://www.dcnr.state.al.us/',
    },
    {
        name: 'Alaska',
        url: 'http://www.adfg.alaska.gov/',
    },
    {
        name: 'Arizona',
        url: 'http://www.gf.state.az.us/',
    },
    {
        name: 'Arkansas',
        url: 'http://www.agfc.com/Pages/default.aspx',
    },
    {
        name: 'California',
        url: 'http://www.dfg.ca.gov/',
    },
    {
        name: 'Colorado',
        url: 'http://wildlife.state.co.us/Pages/default.aspx',
    },
    {
        name: 'Connecticut',
        url: 'http://www.ct.gov/dep/site/default.asp',
    },
    {
        name: 'Delaware',
        url: 'http://www.dnrec.delaware.gov/Pages/Portal.aspx',
    },
    {
        name: 'Florida',
        url: 'http://www.myfwc.com/',
    },
    {
        name: 'Georgia',
        url: 'http://www.gadnr.org/',
    },
    {
        name: 'Hawaii',
        url: 'http://hawaii.gov/dlnr',
    },
    {
        name: 'Idaho',
        url: 'http://fishandgame.idaho.gov/',
    },
    {
        name: 'Illinois',
        url: 'http://dnr.state.il.us/',
    },
    {
        name: 'Indiana',
        url: 'http://www.state.in.us/dnr/',
    },
    {
        name: 'Iowa',
        url: 'http://www.iowadnr.gov/',
    },
    {
        name: 'Kansas',
        url: 'http://www.kdwpt.state.ks.us/',
    },
    {
        name: 'Kentucky',
        url: 'http://fw.ky.gov/',
    },
    {
        name: 'Louisiana',
        url: 'http://www.wlf.louisiana.gov/',
    },
    {
        name: 'Maine',
        url: 'http://www.state.me.us/portal/travel/outdoor.html',
    },
    {
        name: 'Maryland',
        url: 'http://www.dnr.state.md.us/',
    },
    {
        name: 'Massachusetts',
        url: 'http://www.mass.gov/dcr/',
    },
    {
        name: 'Michigan',
        url: 'http://www.michigan.gov/dnr',
    },
    {
        name: 'Minnesota',
        url: 'http://www.dnr.state.mn.us/index.html',
    },
    {
        name: 'Mississippi',
        url: 'http://www.mdwfp.com/',
    },
    {
        name: 'Missouri',
        url: 'http://www.dnr.mo.gov/',
    },
    {
        name: 'Montana',
        url: 'http://fwp.mt.gov/default.html',
    },
    {
        name: 'Nebraska',
        url: 'http://outdoornebraska.ne.gov/',
    },
    {
        name: 'Nevada',
        url: 'http://www.ndow.org/',
    },
    {
        name: 'New Hampshire',
        url: 'http://www.wildlife.state.nh.us/index.html',
    },
    {
        name: 'New Jersey',
        url: 'http://www.state.nj.us/dep/fgw/index.htm',
    },
    {
        name: 'New Mexico',
        url: 'http://www.wildlife.state.nm.us/',
    },
    {
        name: 'New York',
        url: 'http://www.dec.ny.gov/',
    },
    {
        name: 'North Carolina',
        url: 'http://www.enr.state.nc.us/',
    },
    {
        name: 'North Dakota',
        url: 'http://gf.nd.gov/',
    },
    {
        name: 'Ohio',
        url: 'http://www.dnr.state.oh.us/',
    },
    {
        name: 'Oklahoma',
        url: 'http://www.wildlifedepartment.com/',
    },
    {
        name: 'Oregon',
        url: 'http://www.dfw.state.or.us/',
    },
    // {
    //     name: 'Pennsylvania',
    //     url: 'http://www.pgc.state.pa.us/portal/server.pt/community/pgc/9106',
    // },
    {
        name: 'Rhode Island',
        url: 'http://www.dem.ri.gov/',
    },
    {
        name: 'South Carolina',
        url: 'http://www.dnr.sc.gov/index.html',
    },
    {
        name: 'South Dakota',
        url: 'http://www.sdgfp.info/Index.htm',
    },
    {
        name: 'Tennessee',
        url: 'http://www.state.tn.us/twra/index.html',
    },
    {
        name: 'Texas',
        url: 'http://www.tpwd.state.tx.us/',
    },
    {
        name: 'Utah',
        url: 'http://naturalresources.utah.gov/',
    },
    {
        name: 'Vermont',
        url: 'http://www.vtfishandwildlife.com/',
    },
    {
        name: 'Virginia',
        url: 'http://www.dgif.virginia.gov/',
    },
    {
        name: 'Washington',
        url: 'http://wdfw.wa.gov/',
    },
    {
        name: 'West Virginia',
        url: 'http://www.wvweb.com/index.asp',
    },
    {
        name: 'Wisconsin',
        url: 'http://dnr.wi.gov/newurl.html',
    },
    {
        name: 'Wyoming',
        url: 'http://wgfd.wyo.gov/',
    },
];

export function SkinPrep() {
    return (
        <div>
            <div id="skin-prep" className="anchor" />
            <h2>Skin Prep</h2>
            <span>
                1. Be sure skins are thoroughly fleshed and salt dried before shipping.
                <br />
                (Furbearers for intact fur dressing may be sent trapper dried.)
                <br />
                WE DO NOT ACCEPT FRESH OR FROZEN SKINS.
                <br />
                Do not forget to split and dry the tail!
            </span>
            <br />
            <span>
                2. Skins must be completely dry upon receipt or you risk spoilage. Damp salted hides
                will spoil in storage or shipping.
            </span>
            <br />
            <span>
                3. Taxidermy specimens must have all lips and ears turned, tails split, and paws
                fleshed out. Salt dried only! Trapper (air) dry is not acceptable for taxidermy
                tanning.
            </span>
            <br />
            <span>
                4. Dry all capes and mounts with the ears folded down toward the center of the cape.
                This will help prevent them from being damaged during shipping.
            </span>
            <br />
            <span>
                5. Fold all skins into pieces smaller than 4 ft. x 4 ft. or they will not fit in our
                storage bins.
            </span>
            <br />
            <Button type="primary" href={skinPrepPDF} target="_blank">
                Download PDF
            </Button>
            <br />
        </div>
    );
}

export function Shipping() {
    return (
        <div>
            <div id="shipping" className="anchor" />
            <h2 className="add-top">Shipping</h2>
            <h3>INCOMING</h3>
            <span>
                1. Make sure your name, address, and telephone number are clearly written on each
                box. NOTE: WE ARE NOT RESPONSIBLE FOR SKINS SHIPPED TO US WITHOUT CONTACT
                INFORMATION OR IDENTIFICATION.
            </span>
            <br />
            <span>2. Mark multiple packages: BOX 1 of 3, BOX 2 of 3, etc.</span>
            <br />
            <span>3. Include order form and confirm your count.</span>
            <br />
            <span>4. Indicate “taxidermy” or “dressing” for fur bearing species.</span>
            <br />
            <span>
                5. Include your taxidermy license number or the equivalent appropriate license
                number for your state.
            </span>
            <br />
            <br />
            <h3>RETURN SHIPPING</h3>
            <p>
                All items are postage extra. We ship UPS-SIGNATURE REQUIRED or U.S. Postal Service
                Priority Mail. The customer pays shipping and handling costs, plus insurance if
                requested.
            </p>
            <span>
                1. Shipping insurance is not included unless specifically requested by the customer.
                UPS insurance rates apply.
            </span>
            <br />
            <span>
                2. Moyle Mink & Tannery assumes no responsibility for shipments after they have left
                our facility.
            </span>
            <br />
            <Button type="primary" href={shippingInfoPDF} target="_blank">
                Download info PDF
            </Button>
            <Button type="secondary" href={shippingLabelPDF} target="_blank">
                Download label PDF
            </Button>
            <br />
        </div>
    );
}

export function Terms() {
    return (
        <div>
            <div id="terms-and-conditions" className="anchor" />
            <h2>Terms and Conditions</h2>
            <h3>ONLINE CUSTOMER PORTAL TERMS</h3>
            <ul>
                <li>Client must open an on-line account and enter their own orders.</li>
                <li>Prepay order with a credit card.</li>
                <li>
                    On-line orders will be processed 30 days faster than the standard turnaround
                    time. Example: If the standard turnaround time is 90 days, on-line orders will
                    be processed in 60 days. ({ORDER_SERVICE_TYPES.express.titleForPage}
                    orders will be processed as per usual.)
                </li>
                <li>
                    For orders under $625 ($938 for 40-day Rush orders) and shipped within the
                    continental US Shipping & Handling is charged upon order entry.
                </li>
                <li>
                    For orders over $625 ($938 for 40-day Rush orders) and/or shipped to
                    Alaska/Hawaii Shipping & Handling will be charged to your credit card at the
                    time of return shipment.
                </li>
            </ul>
            <br />
            <h3>PRICING</h3>
            <span>
                Generally prices are updated once a year, usually in the fall. However, prices are
                subject to change without notice; please check the website or call for the latest
                update.
            </span>
            <p>
                Prices are based on your skins arriving at Moyle Mink & Tannery fleshed and dried
                properly.
            </p>
            <p>
                Idaho residents are subject to state sales tax unless your tax ID number is on file
                with Moyle Mink & Tannery.
            </p>
            <h3>PAYMENT METHODS</h3>
            <span>
                Checks from established customers* | Visa / MasterCard (credit or debit) | Certified
                checks | Money orders
            </span>
            <p>
                *Established customers are those with more than three orders or who have been a
                Moyle Mink & Tannery customer for more than three years. Non-established customers
                sending a personal/business check may be subjected to delayed shipment while the
                check clears the bank. A service charge of $32.50 will be added to all returned
                checks.
            </p>
            <h3>PAYMENT TERMS</h3>
            <span>No order will be delivered without payment.</span>
            <p>
                If you are picking up skins, no personal checks will be accepted unless you are an
                established customer.
            </p>
            <p>No shipments on partial payments.</p>
            <h4>Past due accounts</h4>
            <ul>
                <li>Accounts are considered past due 30 days from the invoice date.</li>
                <li>Past due accounts are subject to 1.75% service charge per month.</li>
                <li>
                    Accounts past due by three months or longer will result in the sale of the
                    customer skins to pay for tanning charges. Idaho Code 45-805.
                </li>
            </ul>
            <br />
            <h3>DAMAGE POLICY</h3>
            <span>
                Moyle Mink & Tannery is a commercial tannery, and although we try our best to avoid
                it, minor damage sometimes occurs. If the damage is minor and repairable, we will
                expect you to repair it as part of your work as a taxidermist and likewise we will
                make no compensation.
            </span>
            <p>
                Additionally, due to the many variables of Mother Nature including the health of the
                animal, weather, prime condition of the skin, and the improper handling of some
                skins ALL TANNING IS DONE AT THE OWNER RISK. Skins accepted on this basis only.
            </p>
            <h3>Bugs, Mold, or Any Unacceptable Hides/Skins Policy</h3>
            <span>
                Upon opening client shipments at Moyle Mink & Tannery for processing we occasionally
                find hides/skins that have been infested with bugs or hide beetles, this is
                especially true in the spring and summer months. Although we fumigate weekly, we
                cannot risk contaminating all the other clients' skins/hides in our main warehouse.
                The hides cannot be transfered to our main warehouse for storage. It is
                irresponsible to knowingly return hides to clients that are infested with bugs via
                commercial shipments as they could infest other boxes being transported. We can
                offer the following three options:
            </span>
            <p>
                {' '}
                1) The hides can be fumigated and immediately processed. Out of fairness to all our
                other clients the 40-Day Rush service surcharge of 50% will apply.
            </p>
            <p>2) The hides can be picked up by the client or their representative.</p>
            <p>
                3) The hides can be disposed of. Given Moyle Mink & Tannery will have the burden to
                responsibly dispose of the skins/hides, Moyle Mink & Tannery maintains the right to
                take ownership of said skins/hides if it is prudent to do so and finance the
                immediate processing of the skins/hides provided the client has declined to have
                them processed.
            </p>

            <Button type="primary" href={termsAndConditionsPDF} target="_blank">
                Download PDF
            </Button>
            <br />
        </div>
    );
}

export function Links() {
    return (
        <div className="resources-links">
            <div id="links" className="anchor" />
            <h2 className="add-top">Links</h2>
            <a
                type="link"
                href="http://www.nationaltrappers.com/"
                rel="noopener noreferrer"
                target="_blank"
            >
                NATIONAL TRAPPERS ASSOCIATION
            </a>
            <a
                type="link"
                href="http://www.dunnknives.com/"
                rel="noopener noreferrer"
                target="_blank"
            >
                DUNN KNIVES
            </a>
            <a type="link" href="http://www.fur.org/" rel="noopener noreferrer" target="_blank">
                FUR INDUSTRY OF AMERICA
            </a>
            <a
                type="link"
                href="http://www.furtakersofamerica.com/"
                rel="noopener noreferrer"
                target="_blank"
            >
                FUR TAKERS OF AMERICA
            </a>
            <a
                type="link"
                href="http://www.shootguns.info/"
                rel="noopener noreferrer"
                target="_blank"
            >
                INTERNET SHOOTING DIRECTORY
            </a>
            <a
                type="link"
                href="http://www.wvtrappers.com/"
                rel="noopener noreferrer"
                target="_blank"
            >
                WEST VIRGINIA TRAPPERS ASSOCIATION
            </a>
            <a
                type="link"
                href="http://coloradotrapper.com/"
                rel="noopener noreferrer"
                target="_blank"
            >
                COLORADO TRAPPERS ASSOCIATION
            </a>
            <a
                type="link"
                href="http://www.idahotrappers.org/"
                rel="noopener noreferrer"
                target="_blank"
            >
                IDAHO TRAPPERS ASSOCIATION
            </a>
            <a
                type="link"
                href="http://www.montanatrappers.org/"
                rel="noopener noreferrer"
                target="_blank"
            >
                MONTANA TRAPPERS ASSOCIATION
            </a>
            <a
                type="link"
                href="http://www.northdakotafurtakers.com/"
                rel="noopener noreferrer"
                target="_blank"
            >
                NORTH DAKOTA FUR TAKERS
            </a>
            <a type="link" href="http://www.wistrap.org/" rel="noopener noreferrer" target="_blank">
                WINSCONSIN TRAPPERS ASSOCIATION
            </a>
            <a
                type="link"
                href="http://www.nationaltaxidermists.com/"
                rel="noopener noreferrer"
                target="_blank"
            >
                NATIONAL TAXIDERMYSTS ASSOCIATION
            </a>
            <a
                type="link"
                href="http://www.taxidermy.net/"
                rel="noopener noreferrer"
                target="_blank"
            >
                TAXIDERMY.NET
            </a>
        </div>
    );
}
